import React from "react";

import Typography from "@mui/material/Typography";

import AttendanceIndicator from "@app/analytics/components/AttendanceIndicator";
import TableCell from "@app/analytics/components/Table/TableCell";
import type { UserMeeting } from "@app/common/types";
import { formatStartAndEndTime } from "@app/common/utils";

import RecurringMeetingBadge from "@rui/RecurringMeetingBadge";
import Stack, { Row } from "@rui/Stack";

import { getReportStartEndTimes } from "../utils";

const DateAndTimeCell = ({
  isNested = false,
  isSummary = false,
  report,
  showAttendance = false,
}: {
  isNested?: boolean;
  isSummary?: boolean;
  report: UserMeeting;
  showAttendance?: boolean;
}) => {
  const { startTimeToDisplay, endTimeToDisplay } = getReportStartEndTimes(
    report,
    isSummary
  );

  const numAdditionalMeetingInstances = (report.instances ?? []).length - 1;

  return (
    <TableCell sx={{ color: "shades.neutral.700" }}>
      <Stack spacing={0.5}>
        <Row variant="left" spacing={0.5}>
          <Typography variant="bodySecondaryReg">
            {startTimeToDisplay?.toLocaleString({
              weekday: "short",
              month: "short",
              day: "numeric",
              year: "numeric",
            })}
            {numAdditionalMeetingInstances > 0 &&
              ` +${numAdditionalMeetingInstances}`}
          </Typography>
          {!isNested && report.seriesId && (
            <RecurringMeetingBadge size="10px" />
          )}
        </Row>
        <Row variant="left" spacing={1.5}>
          <Row spacing={0.5} variant="left">
            <Typography variant="labelReg" sx={{ color: "shades.neutral.500" }}>
              {formatStartAndEndTime(startTimeToDisplay, endTimeToDisplay)}
            </Typography>
            {showAttendance && (
              <AttendanceIndicator meeting={report} showTooltip />
            )}
          </Row>
        </Row>
      </Stack>
    </TableCell>
  );
};

export default DateAndTimeCell;
